import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Collection from './pages/Collection';
import Product from './pages/Product';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Page from './pages/Page';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Order from './pages/Order';
import Account from './pages/Account';
import Wishlist from './pages/Wishlist';
import TrackOrder from './pages/TrackOrder';
import NotFound from './pages/NotFound';
import { PageLoader } from './components/common/Spinner';

// Admin panel is code-split so storefront visitors never download it.
const AdminApp = lazy(() => import('./admin/AdminApp'));

export default function App() {
  return (
    <Routes>
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<PageLoader />}>
            <AdminApp />
          </Suspense>
        }
      />
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="collections" element={<Navigate to="/collections/all" replace />} />
        <Route path="collections/:slug" element={<Collection />} />
        <Route path="collections/:slug/products/:productSlug" element={<Product />} />
        <Route path="products" element={<Navigate to="/collections/all" replace />} />
        <Route path="products/:slug" element={<Product />} />
        <Route path="search" element={<Collection search />} />
        <Route path="blogs" element={<Blog />} />
        <Route path="blogs/:blog" element={<Blog />} />
        <Route path="blogs/:blog/:slug" element={<BlogPost />} />
        <Route path="pages/:slug" element={<Page />} />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="order/:id" element={<Order />} />
        <Route path="track-order" element={<TrackOrder />} />
        <Route path="account" element={<Account />} />
        <Route path="wishlist" element={<Wishlist />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
